import { useQuery } from "@tanstack/react-query";
import { programApi } from "@bw/shared/api";
import { useAuth } from "@bw/shared/hooks";
import type { ProgramLearningSpaceResponse } from "@bw/shared/types/generated";

export function useLearningSpace(programId: string | undefined, enabled = true) {
  const { user, loading } = useAuth();
  const canQuery = Boolean(user?.uid && programId) && !loading && enabled;
  const query = useQuery<ProgramLearningSpaceResponse>({
    queryKey: ["classes", "learning-space", user?.uid ?? null, programId ?? ""] as const,
    queryFn: () => programApi.getLearningSpace(programId as string),
    enabled: canQuery,
    refetchOnMount: "always",
    retry: false,
  });
  return {
    ...query,
    data: canQuery && query.isFetchedAfterMount && !query.isError ? query.data : undefined,
  };
}
